const ITEMS = [
  "Dry Van",
  "Reefer",
  "Omaha, Nebraska",
  "US DOT 3452744",
  "Call 402-639-1139",
  "Shippers & Brokers",
];

function Row({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <div key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-3xl font-bold uppercase tracking-wide text-white/90 sm:text-5xl">
            {item}
          </span>
          <span className="h-3 w-3 rotate-45 bg-cobalt" />
        </div>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="marquee-paused relative overflow-hidden border-y border-white/10 bg-panel/40 py-6"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
